export default "__VITE_ASSET__BSQ8UAr4__"